/**
 * Dreymir Artisan — Theme JavaScript
 * Minimal, defer-loaded, no frameworks.
 */
(function () {
  'use strict';

  // --- Mobile hamburger toggle ---
  function initMobileMenu() {
    var toggle = document.querySelector('.js-mobile-menu-toggle');
    var menu = document.querySelector('.js-mobile-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // --- Accordion icon flip (native <details> handles open/close, we just rotate icon) ---
  function initAccordionIcons() {
    var summaries = document.querySelectorAll('.accordion__summary');
    summaries.forEach(function (summary) {
      summary.addEventListener('click', function () {
        var detail = summary.closest('details');
        var icon = summary.querySelector('.accordion__icon');
        // CSS handles rotation via [open] selector, but for dynamic toggling
        // we rely on the 'open' attribute being added/removed by browser.
        // Force repaint issue: just flip manually for reliability
        if (icon) {
          setTimeout(function () {
            if (detail.open) {
              icon.style.transform = 'rotate(180deg)';
            } else {
              icon.style.transform = 'rotate(0deg)';
            }
          }, 10);
        }
      });
    });
  }

  // --- Quantity stepper: update quantity and submit cart form ---
  function initQuantitySteppers() {
    document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
      var minus = stepper.querySelector('.js-qty-minus');
      var plus = stepper.querySelector('.js-qty-plus');
      var input = stepper.querySelector('.js-qty-input');
      var form = stepper.closest('form');
      if (!minus || !plus || !input) return;

      function update(val) {
        var n = parseInt(val, 10);
        if (isNaN(n) || n < 1) n = 1;
        input.value = n;
        if (form) form.submit();
      }

      minus.addEventListener('click', function () {
        update(parseInt(input.value, 10) - 1);
      });
      plus.addEventListener('click', function () {
        update(parseInt(input.value, 10) + 1);
      });
    });
  }

  // --- Sticky header: hide on scroll down, show on scroll up ---
  function initStickyHeader() {
    var header = document.querySelector('.js-sticky-header');
    if (!header) return;
    var lastScroll = 0;
    var ticking = false;

    function update() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY < lastScroll - 10) {
        // Scrolling up
        header.classList.remove('nav-top--hidden');
      } else if (scrollY > lastScroll + 10 && scrollY > 100) {
        // Scrolling down past threshold
        header.classList.add('nav-top--hidden');
      }
      lastScroll = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    });
  }

  // --- Select underline: add has-value class for floating label behavior ---
  function initSelectUnderline() {
    document.querySelectorAll('.select-underline').forEach(function (select) {
      updateClass(select);
      select.addEventListener('change', function () {
        updateClass(select);
      });
    });

    function updateClass(select) {
      if (select.value) {
        select.classList.add('has-value');
      } else {
        select.classList.remove('has-value');
      }
    }
  }

  // --- Hero carousel: dot navigation + auto-advance ---
  function initHeroCarousel() {
    var carousels = document.querySelectorAll('.js-hero-carousel, .js-hero-carousel-mobile');
    carousels.forEach(function (carousel) {
      var sectionId = carousel.dataset.section;
      var dots = document.querySelectorAll('.hero-carousel__dot[data-slide]');
      if (dots.length < 2) return;

      var slides = carousel.querySelectorAll('[class*="hero-carousel__slide-"]');
      var current = 0;
      var autoInterval;

      function goTo(index) {
        current = index;
        var slide = slides[index];
        if (slide) {
          carousel.scrollTo({ left: slide.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
        }
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        if (dots[index]) dots[index].classList.add('is-active');
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.slide));
          resetAuto();
        });
      });

      function startAuto() {
        autoInterval = setInterval(function () {
          goTo((current + 1) % slides.length);
        }, 5000);
      }

      function resetAuto() {
        clearInterval(autoInterval);
        startAuto();
      }

      // Update active dot on scroll
      carousel.addEventListener('scroll', function () {
        var scrollLeft = carousel.scrollLeft;
        var slideWidth = carousel.offsetWidth;
        var idx = Math.round(scrollLeft / slideWidth);
        if (idx !== current && idx >= 0 && idx < slides.length) {
          current = idx;
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          if (dots[current]) dots[current].classList.add('is-active');
        }
      }, { passive: true });

      startAuto();
    });
  }

  // --- Product video autoplay fallback (belt-and-suspenders for aggressive browsers) ---
  function initProductVideo() {
    // Mobile carousel keeps autoplaying: there is no hover on touch.
    document.querySelectorAll('.product-carousel__video video').forEach(function(v) {
      v.play().catch(function() {});
    });

    // Desktop gallery video plays on hover instead of looping from page load.
    var frame = document.querySelector('.product-detail__main-image');
    var video = frame ? frame.querySelector('.product-detail__video video') : null;
    if (!frame || !video) return;
    frame.addEventListener('mouseenter', function() {
      video.play().catch(function() {});
    });
    frame.addEventListener('mouseleave', function() {
      video.pause();
    });
  }

  // --- Card video scroll-into-view autoplay ---
  function initCardVideos() {
    var cards = document.querySelectorAll('.product-card--has-video');
    if (!cards.length) return;

    var mql = window.matchMedia('(max-width: 767px)');
    var activeVideo = null;
    var activeContainer = null;
    var mobileObserver = null;
    var mobileRatios = null;
    var desktopListeners = [];

    function pauseActive() {
      if (activeVideo) { activeVideo.pause(); activeVideo = null; }
      if (activeContainer) { activeContainer.style.opacity = '0'; activeContainer = null; }
    }

    function teardown() {
      if (mobileObserver) { mobileObserver.disconnect(); mobileObserver = null; }
      if (mobileRatios) { mobileRatios.clear(); mobileRatios = null; }
      desktopListeners.forEach(function(e) {
        e.card.removeEventListener('mouseenter', e.onEnter);
        e.card.removeEventListener('mouseleave', e.onLeave);
      });
      desktopListeners = [];
      pauseActive();
    }

    function setupMobile() {
      teardown();
      mobileRatios = new Map();

      function pickWinner() {
        var best = null, bestRatio = 0;
        mobileRatios.forEach(function(ratio, card) {
          if (ratio > bestRatio) { bestRatio = ratio; best = card; }
        });
        if (!best || bestRatio < 0.6) { pauseActive(); return; }
        // Only play if carousel is on slide 0 (video visible), not swiped to an image
        var carousel = best.querySelector('.product-card__carousel');
        if (carousel) {
          var slideWidth = carousel.offsetWidth;
          var idx = slideWidth ? Math.round(carousel.scrollLeft / slideWidth) : 0;
          if (idx !== 0) { pauseActive(); return; }
        }

        var video = best.querySelector('.product-card__video video');
        var container = video ? video.parentElement : null;
        if (!video) return;
        if (video === activeVideo) return;
        pauseActive();
        activeVideo = video;
        activeContainer = container;
        video.play().catch(function() {});
        if (container) container.style.opacity = '1';
      }

      mobileObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          mobileRatios.set(entry.target, entry.intersectionRatio);
          if (!entry.isIntersecting) {
            var carousel = entry.target.querySelector('.product-card__carousel');
            if (carousel) carousel.scrollLeft = 0;
          }
        });
        pickWinner();
      }, { threshold: [0, 0.3, 0.6, 0.8, 1] });

      cards.forEach(function(c) { mobileObserver.observe(c); });
    }

    function setupDesktop() {
      teardown();

      cards.forEach(function(card) {
        var video = card.querySelector('.product-card__video video');
        if (!video) return;

        function onEnter() {
          video.load();
          video.play().catch(function() {});
        }

        function onLeave() {
          video.pause();
          video.removeAttribute('src');
          video.load();
        }

        card.addEventListener('mouseenter', onEnter);
        card.addEventListener('mouseleave', onLeave);

        desktopListeners.push({ card: card, onEnter: onEnter, onLeave: onLeave });
      });
    }

    function handleChange() {
      if (mql.matches) {
        setupMobile();
      } else {
        setupDesktop();
      }
    }

    mql.addListener(handleChange);
    handleChange();
  }

  // --- Product card carousel: swipeable image gallery with dot indicators ---
  function initCardCarousels() {
    var mql = window.matchMedia('(max-width: 767px)');
    if (!mql.matches) return;
    document.querySelectorAll('.product-card__carousel').forEach(function(carousel) {
      var card = carousel.closest('.product-card');
      if (!card) return;
      var dots = card.querySelectorAll('.product-card__dot');
      if (!dots.length) return;

      function syncSlide() {
        var slideWidth = carousel.offsetWidth;
        if (!slideWidth) return;
        var idx = Math.round(carousel.scrollLeft / slideWidth);
        if (idx < 0) idx = 0;
        if (idx >= dots.length) idx = dots.length - 1;
        dots.forEach(function(d, i) {
          d.classList.toggle('product-card__dot--active', i === idx);
        });
      }

      // Update dots on scroll
      carousel.addEventListener('scroll', syncSlide, { passive: true });

      // Track swipe to prevent navigation on drag
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carousel.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 10) {
          card.dataset.swiped = 'true';
          setTimeout(function() { card.dataset.swiped = 'false'; }, 100);
        }
      }, { passive: true });

      // Recalculate slide width on resize
      window.addEventListener('resize', syncSlide, { passive: true });
    });

    // Click navigation on product cards (skip if swiped or interactive element)
    document.querySelectorAll('.product-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest('a')) return;
        if (e.target.closest('button')) return;
        if (e.target.closest('form')) return;
        if (card.dataset.swiped === 'true') return;
        var url = card.dataset.productUrl;
        if (url) window.location.href = url;
      });
    });
  }

  // --- Closeup viewer: click any gallery media to open it, arrows page through ---
  function initProductLightbox() {
    var box = document.querySelector('.js-lightbox');
    var listEl = document.querySelector('.js-media-list');
    if (!box || !listEl) return;

    var items;
    try {
      items = JSON.parse(listEl.textContent);
    } catch (err) {
      return;
    }
    if (!items || !items.length) return;

    var img = box.querySelector('.js-lightbox-img');
    var video = box.querySelector('.js-lightbox-video');
    var closeBtn = box.querySelector('.product-lightbox__close');
    var prevBtn = box.querySelector('.js-lightbox-prev');
    var nextBtn = box.querySelector('.js-lightbox-next');
    if (!img || !video || !closeBtn) return;

    var current = 0;
    var lastFocus = null;

    if (items.length < 2) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }

    function clearStage() {
      video.pause();
      video.hidden = true;
      video.removeAttribute('poster');
      while (video.firstChild) video.removeChild(video.firstChild);
    }

    function show(index) {
      current = (index + items.length) % items.length;
      var item = items[current];

      if (item.type === 'video') {
        img.hidden = true;
        img.removeAttribute('src');
        clearStage();
        (item.sources || []).forEach(function(source) {
          var el = document.createElement('source');
          el.src = source.url;
          el.type = source.type;
          video.appendChild(el);
        });
        if (item.poster) video.poster = item.poster;
        video.hidden = false;
        video.load();
        video.play().catch(function() {});
        return;
      }

      clearStage();
      img.hidden = false;
      img.src = item.src;
      img.alt = item.alt || '';
    }

    function open(index) {
      lastFocus = document.activeElement;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      show(index);
      closeBtn.focus();
    }

    function close() {
      clearStage();
      box.hidden = true;
      document.body.style.overflow = '';
      img.removeAttribute('src');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // The main preview is the first media item, video included, so clicking it
    // opens the viewer on the video rather than on a still behind it.
    var main = document.querySelector('.product-detail__main-image');
    if (main) {
      main.style.cursor = 'zoom-in';
      main.addEventListener('click', function() {
        open(0);
      });
    }

    // Thumbnails do not change the main preview; they are entry points.
    document.querySelectorAll('.js-product-thumb').forEach(function(thumb) {
      thumb.style.cursor = 'zoom-in';
      thumb.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-media-index'), 10);
        open(isNaN(index) ? 0 : index);
      });
    });

    // Mobile carousel, same list order, skipping the poster behind a video.
    var slides = Array.prototype.slice.call(document.querySelectorAll('.product-carousel__slide'));
    slides.forEach(function(slide) {
      var el = slide.querySelector('img');
      if (!el || slide.querySelector('.product-carousel__media')) return;
      el.style.cursor = 'zoom-in';
      el.addEventListener('click', function() {
        open(slides.indexOf(slide));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { show(current + 1); });

    box.querySelectorAll('.js-lightbox-close').forEach(function(el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function(e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    // Keep Tab inside the dialog: the arrows, the close button and the video
    // controls are all in here, so there is somewhere sensible to send it.
    box.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusables = box.querySelectorAll(
        'button:not([hidden]), video:not([hidden]), [href]:not([hidden])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // --- Rotating announcement bar ---
  function initAnnouncementBar() {
    var bar = document.querySelector('.js-announcement-bar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.announcement-bar__message');
    if (msgs.length < 2) return;
    var current = 0;
    var delay = parseInt(bar.dataset.delay) || 5000;
    setInterval(function() {
      msgs[current].classList.remove('is-visible');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('is-visible');
    }, delay);
  }

  // --- Init all ---
  function init() {
    initMobileMenu();
    initAccordionIcons();
    initQuantitySteppers();
    initStickyHeader();
    initSelectUnderline();
    initHeroCarousel();
    initProductVideo();
    initCardVideos();
    initCardCarousels();
    initProductLightbox();
    initAnnouncementBar();
  }

  // Panel toggle for Judge.me's reviews modal from our own trigger (the hero rating
  // line). The app owns the modal; this only opens it, and prefers the app's own entry
  // point because the floating tab button can be hidden by CSS on phones — a hidden
  // button still receives .click(), but its API call is the supported path.
  // The tab widget reports itself "done setting up" a beat before it will actually open,
  // and a call landing in that window is swallowed with no error (measured over CDP: the
  // same click opened the modal every time from ~3s after ready, and sometimes did nothing
  // at 0s). So ask once more — but stop the moment a modal shows up, or closing it quickly
  // would have it reopen under the customer.
  // ponytail: no fallback surface. If Judge.me is ever removed the metafields freeze, so
  // the line keeps rendering and the click does nothing; drop the button then.
  function openReviewsModal() {
    var fire = function () {
      if (window.jdgm && typeof window.jdgm.showReviewsTab === 'function') {
        window.jdgm.showReviewsTab();
        return;
      }
      var tabButton = document.querySelector('.jdgm-revs-tab-btn');
      if (tabButton) tabButton.click();
    };

    var started = Date.now();
    var retried = false;

    var watch = function () {
      if (document.querySelector('.jdgm-modal')) return;
      var waited = Date.now() - started;
      if (retried || waited > 1500) return;
      if (waited >= 700) {
        retried = true;
        fire();
      }
      window.setTimeout(watch, 150);
    };

    fire();
    window.setTimeout(watch, 150);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-jdgm-reviews]');
    if (!trigger) return;
    e.preventDefault();
    openReviewsModal();
  });

  // Consentmo cookie preferences — intercept hash link from footer
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="#consent-preferences"]');
    if (link && typeof showPreferences === 'function') {
      e.preventDefault();
      showPreferences(link);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
